import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { GroupRowRendererParams } from './group-row-renderer-params';
import { GroupRowRendererService } from './group-row-renderer.service';

@Component({
    selector: 'pui-group-data-inner-row',
    template: `<span [matTooltip]="showTooltip ? fieldName + ': ' + value : ''">{{ fieldName }}: {{ value }}</span>`,
    styleUrls: ['../group-row-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupRowRendererComponent implements ICellRendererAngularComp {
    @Input() value: any;
    @Input() fieldName = '';
    @Input() field!: string;
    @Input() showTooltip = false;

    constructor(private groupRowRendererService: GroupRowRendererService) {}

    agInit(params: ICellRendererParams & GroupRowRendererParams): void {
        const groupRowData = params.fieldsKeys.get(params.node.field ?? '');
        this.fieldName = groupRowData?.visibleName ?? '';
        this.value = this.groupRowRendererService.getGroupRowValue(params, groupRowData?.valueFormatter ?? '');
        this.showTooltip = params.showGroupTooltip || false;
    }

    refresh(): boolean {
        return false;
    }
}
